import React, { ReactElement, ReactNode } from 'react';
import { i18nKey } from '../../../declaration';
import i18n from '../../../common/i18n';
import { DialogErrorBody } from './error';

const defaults = {
    i18n: function(key: i18nKey) {
        if (Array.isArray(key)) {
            return key[0];
        }
        return key;
    },
    useDynamicPageHeightFix: 100 as number | false,
    pageClass: 'page-min-height',
    loginDelay1: 3000,
    loginDelay2: 7000,
    onboardingApi: '/api/onboarding',
    affidavitResidenceMandatory: false,

    styleOverrides: {},

    // prechod na / otvorenie login formulara
    gotoLoginForm: function() {
        window.location.href = '/prihlasenie';
    },

    // prechod na / otvorenie login formulara
    gotoHomepage: function() {
        window.location.href = '/';
    },

    goBackToStep0: function() {
        window.location.href = '/doregistracia/dokoncenie-registracie';
    },

    // vrati promisu, ktora urobi 1 XHR call
    doLoginAttempt: function(login, password): Promise<any> {
        console.warn('doLoginAttempt: not implemented', login, password);
        return Promise.reject('doLoginAttempt: not implemented');
    },

    // funkcia je zavolana po uspesnom XHR logine
    onLogin: function() {
        console.log('onLogin');
        window.location.href = '/';
    },

    // hook na update URL adresy, preferovane metoda je history.replace
    onPageChanged: function(url) {
        console.warn('onPageChanged: not implemented', url);
    },

    onError: function(error) {
        console.warn('onError: not implemented', error);
    },

    // funkcia musi vracia close handler, a rovnako injecnut do elementu body close handler ako atribut 'close'
    openDialog: function(title?: ReactNode, body?: ReactElement, options?: Object): Function | undefined {
        console.warn('openDialog: not implemented');
        return () => {};
    },

    openArticle: function(code, title?: string) {
        console.warn('openArticle: not implemented', code, title);
    },
    openClientParamChangeVerificationModal: function(forcedActionCrm) {
        console.warn('openClientParamChangeVerificationModal: not implemented', forcedActionCrm);
    },
    open: function(type: OnbDialogType, dialogParams?: Object) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get('embedded') === '') {
            window.parent.postMessage({ method: 'OPEN_DIALOG', type, dialogParams });
        } else {
            this.openPlatformDialog(type, dialogParams);
        }
    },
    openPlatformDialog: function(type: OnbDialogType, dialogParams?: any) {
        //TODO use nuiCtx openDialog, create NuiDialog for every dialog in list, delete all the overrides of
        switch (type) {
            case 'ARTICLE':
                return this.openArticle(dialogParams.code, dialogParams.title);
            case 'ERROR':
                return this.openDialog(
                    null,
                    // @ts-ignore but fix me
                    <DialogErrorBody
                        uiError={
                            dialogParams.uiError || {
                                code: dialogParams.status,
                                i18nMessage: i18n('nui.client.param.change.error.' + dialogParams.code)
                            }
                        }
                    />,
                    { className: 'dialog-onb' }
                );
            case 'CLIENT_PARAM_CHANGE_VERIFICATION':
                return this.openClientParamChangeVerificationModal(dialogParams.forcedActionCrm);
        }
    },
    // sposob ako synchronizovat forcedActions spat do zakladneho modelu
    setForcedActions: function(forcedActions, db) {}
};

export type OnbDialogType = 'ERROR' | 'ARTICLE' | 'CLIENT_PARAM_CHANGE_VERIFICATION';

export type RegistrationConfiguration = typeof defaults;
type InitializeConfigurationArgs = Partial<RegistrationConfiguration>;
type LazyInitialization = () => InitializeConfigurationArgs;

let lazy: LazyInitialization;
let merged: RegistrationConfiguration;

export function initializeRegistration(config: InitializeConfigurationArgs | LazyInitialization) {
    if (typeof config === 'function') {
        lazy = config;
        return;
    }
    merged = Object.assign(defaults, config);
}

export function getConfig() {
    if (!merged) {
        initializeRegistration(lazy());
    }
    return merged;
}

export function getStyleOverride(className) {
    return getConfig().styleOverrides[className];
}
